<template>
  <div class="app-flow-page">
    <div class="search-box search-box-samll mb-lg">
      <el-form ref="searchForm" size="small"
               :model="searchObj"
               label-position="left"
               label-width="auto">
        <el-form-item label="接口分类" class="mr-lg">
          <el-select class="width-full" v-model="searchObj.business_id" placeholder="请选择" clearable>
            <el-option v-for="item in businessList" :key="item.id" :label="item.business_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接口名称" class="mr-lg">
          <el-input v-model="searchObj.interface_name" maxlength="20" clearable placeholder="请输入接口名称"></el-input>
        </el-form-item>
        <el-form-item label="api_method" class="mr-lg">
          <el-input v-model="searchObj.method" maxlength="100" clearable placeholder="请输入api_method"></el-input>
        </el-form-item>
        <div class="inline-block v-top">
          <div class="search-btn" @click="handleCurrentChange(1)">查询</div>
        </div>
      </el-form>
    </div>
    <div class="content-box no-hover-bg">
      <el-table
          :data="apiList"
          border
          size="mini"
          style="width: 100%">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="接口ID" width="80"></el-table-column>
        <el-table-column prop="business_name" label="接口分类" width="130"></el-table-column>
        <el-table-column prop="interface_name" label="接口名称">
          <template slot-scope="scope">
            <span class="text-info pointer" @click="openApiDialog(scope.row)">{{scope.row.interface_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="request_virtual" label="api_method"></el-table-column>
<!--        <el-table-column label="已使用/配额" width="120">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{scope.row.used_day}} / {{scope.row.visit_day}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="获取时间" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.created_at === '0000-00-00 00:00:00' ? '' : scope.row.created_at}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pagination-box" v-if="totalSum > 0">
        <el-pagination
            class="paging"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 50, 100, 200]"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            :total="totalSum"
            layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'controlAppFlow',
    data() {
      return {
        appId: '',
        typeAccount: '', // app 账户体系类型
        searchObj: {
          business_id: null, // 接口分类id
          interface_name: null, // 接口名称
          method: null // 映射method
        },
        pageSize: 10,
        pageNo: 1,
        totalSum: 0,
        businessList: [], // 接口分类列表
        apiList: [] // 授权的api列表
      }
    },
    computed: {
      // 遍历查找api页面的菜单id 用于跳转详情时使用
      apiMenuId() {
        let apiMenuId = '';
        let menuList = this.$store.state.app.menuList;
        menuList.forEach(val => {
          if(val.link_url.indexOf('doc/api') !== -1) {
            apiMenuId = val.id;
          }
        });
        return apiMenuId;
      }
    },
    mounted() {
      this.appId = this.$route.params.appId;
      this.getAppDetail();
      this.handleCurrentChange(1);
    },
    methods: {
      // 打开api详情
      openApiDialog(api) {
        this.$axios.get("/ajax/developer/api/doc/path", {params: {
            api_method: api.request_virtual
        }}).then(res => {
          if (res.data.ret === 0) {
            let path = res.data.data;
            this.$router.push({
              path: path
            })
          }
        })
      },
      // 获取应用详情
      getAppDetail() {
        this.server.post("/ajax/control/panel/app/info", {
          app_id: this.appId
        }).then(res => {
          this.typeAccount = res.data.data.type_account;
          this.getAppTypeList();
        }).catch(e => {});
      },
      // 获取应用类型列表
      getAppTypeList() {
        this.server.post("/ajax/api/doc/business/category", {
          app_id: this.appId
        }).then(res => {
          this.businessList = res.data.data;
        });
      },
      handleSizeChange(size) {
        this.pageNo = 1;
        this.pageSize = size;
        this.getListData();
      },
      handleCurrentChange(index) {
        this.pageNo = index;
        this.getListData();
      },
      // 获取数据列表
      getListData() {
        this.server.post("/ajax/control/panel/app/api/auth/list", {
          ...this.searchObj,
          app_id: this.appId,
          page_size: this.pageSize,
          page_no: this.pageNo
        }).then(res => {
          this.apiList = res.data.data.list || [];
          this.totalSum = parseInt(res.data.data.total);
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-flow-page {
    padding: 30px 40px;
  }
  /deep/ .el-table--mini {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/control/app/flow.vue